document.addEventListener('DOMContentLoaded', function () {
  
  // Menu Hover Event
  menuHoverEvent();
  
  // featured collection swiper
  featuredCollectionSwiper();

  //collection sub-category slider
  collectionSubCategorySwiper();
  
  // mobile menu close button start
  var detailsContainer = document.querySelector('#Details-menu-drawer-container summary');
  var menuDrawer = document.querySelector('#menu-drawer summary');
  if (menuDrawer && detailsContainer) {
    menuDrawer.addEventListener('click', function (event) {
      event.preventDefault(); 
      detailsContainer.click();
    });
  }
  // mobile menu close button end

  
  // Accordion section
  const accordionTitles = document.querySelectorAll(".section-accordion-inner .accordion-title");
  const allPanels = document.querySelectorAll(".section-accordion-inner .panel");
  
  if (accordionTitles.length > 0 && allPanels.length > 0) {
    // Open the first accordion by default
    accordionTitles[0].classList.add("active");
    allPanels[0].style.maxHeight = allPanels[0].scrollHeight + "px";
  
    accordionTitles.forEach(title => {
      title.addEventListener("click", function () {
        const panel = this.nextElementSibling;
        if (!panel || !panel.classList.contains("panel")) return;
  
        // Close other panels
        allPanels.forEach(p => {
          if (p !== panel) {
            p.style.maxHeight = null;
          }
        });
  
        // Remove 'active' class from other titles
        accordionTitles.forEach(t => {
          if (t !== this) {
            t.classList.remove("active");
          }
        });
  
        // Toggle active class and open/close panel
        this.classList.toggle("active");
  
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    });
  }


  //  PDP page media gallery swiper
  productMediaGallery();

 //  pdp page metafield html convert js
  let accBoxEle = document.querySelectorAll('.product__info-container .pdp-accordian, .product__inner-media-wrapper .pdp-accordian');
  if (accBoxEle.length) {
    accBoxEle.forEach(accordion => {
      const sizeChartData = accordion.querySelector('.accordian-metadata');
      const sizeChartContent = accordion.querySelector('.accordian-metadata-content');
      if (sizeChartData && sizeChartContent) {
        sizeChartContent.innerHTML = sizeChartData.textContent.trim();
        sizeChartData.remove();
      }
    });
  }
  
});

function featuredCollectionSwiper() {
  const sectionEl = document.querySelectorAll('.featured-collection-section');
  if(!sectionEl.length) return;
  
  sectionEl.forEach((swiperEl, index) => {
      const swipers = swiperEl.querySelector('[data-featured-collection-swiper]');
      const nextBtn = swiperEl.querySelector('.swiper-button-next');
      const prevBtn = swiperEl.querySelector('.swiper-button-prev');
      const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');

      new Swiper(swipers, {
        slidesPerView: 1.15,
        spaceBetween: 12,
        navigation: nextBtn && prevBtn ? {
          nextEl: nextBtn,
          prevEl: prevBtn,
        } : undefined,
        scrollbar: scrollbarEl ? {
          el: scrollbarEl,
          draggable: true
        } : undefined,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 24
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 24
          }
        },
      });
  });
}

function collectionSubCategorySwiper() {
  const sectionEl = document.querySelector('[data-sub-category-grid]');
  if(!sectionEl) return;
  
  const nextBtn = sectionEl.closest('.header-collections-multicolumn').querySelector('.swiper-button-next');
  const prevBtn = sectionEl.closest('.header-collections-multicolumn').querySelector('.swiper-button-prev');
      
  new Swiper(sectionEl, {
    slidesPerView: 8,
    spaceBetween: 10,
    navigation: nextBtn && prevBtn ? {
      nextEl: nextBtn,
      prevEl: prevBtn,
    } : undefined,
    breakpoints: {
      1367: {
        slidesPerView: 10
      }
    },
    on: {
      init() {
        if(this.navigation?.nextEl){
          this.navigation?.nextEl.classList.remove('hidden');
        }
        if(this.navigation?.prevEl){
          this.navigation?.prevEl.classList.remove('hidden');
        }
      },
    }
  });
}


function productMediaGallery() {
  const thumbSwiperEle = document.querySelector(`.thumbnails-swiper`);
  const mainGallrySwiperEle = document.querySelector(`.product-media-swiper`);
  
  if(!thumbSwiperEle || !mainGallrySwiperEle) return;

  const thumbNextBtn = thumbSwiperEle.parentElement?.querySelector(`.button-next-bottom`) || null;
  const thumbPrevBtn = thumbSwiperEle.parentElement?.querySelector(`.button-prev-top`) || null;
  
  var thumbnailSwiper = new Swiper(thumbSwiperEle, {
    direction: 'vertical',
    spaceBetween: 12,
    slidesPerView: 5,
    watchSlidesProgress: true,
    freeMode: true,
    navigation: {
      nextEl: thumbNextBtn,
      prevEl: thumbPrevBtn
    }
  });

  window.GallrySwiper = new Swiper(mainGallrySwiperEle, {
    spaceBetween: 10,
    watchSlidesProgress: true,
    thumbs: {
      swiper: thumbnailSwiper
    },
    pagination: {
      el: ".product-media-swiper-pagination"
    },
    breakpoints: {
      1200: {
        pagination: false
      }
    }
  });
}



function toggleAccordion(element) {
  const openClass = "active";
  let mainParent, currentParent;
  
  if(element.closest('.pdp-accordian')){
    mainParent = document.querySelectorAll(".product-accordion--wrapper .pdp-accordian");
    currentParent = element.closest(".pdp-accordian");  
  }else if(element.closest('.variant-accordion')){
    mainParent = document.querySelectorAll(".product__info-container .variant-accordion");
    currentParent = element.closest(".variant-accordion");
  }else if(element.closest('.filter-accordion')){
    mainParent = document.querySelectorAll("#FacetFiltersFormMobile  .filter-accordion");
    currentParent = element.closest(".filter-accordion");
  }
  const content = currentParent.querySelector(".panel");

  if (currentParent.classList.contains(openClass)) {
    currentParent.classList.remove(openClass);
    currentParent.querySelector(".panel").style.maxHeight = "0px";
  } else {
    mainParent.forEach((e) => {
      if (e.classList.contains(openClass)) {
        e.classList.remove(openClass);
        e.querySelector(".panel").style.maxHeight = "0px";
      }
    });
    currentParent.classList.add(openClass);
    content.style.maxHeight = `${content.scrollHeight + 10}px`;
  }
}


function menuHoverEvent() {
  const headerMenuLists = document.querySelectorAll('header-menu > details');
  if(headerMenuLists.length){
    headerMenuLists.forEach(list => {
      //on hover
      list.addEventListener("mouseenter", (e) => {
        e.target.setAttribute('open','');
        if(e.target.querySelector('summary')){
          e.target.querySelector('summary').setAttribute('aria-expanded','true');
        }
      });
      //on hover out
      list.addEventListener("mouseleave", (e) => {
        headerMenuLists.forEach(list => {
          list.removeAttribute('open');
          if(list.querySelector('summary')){
            list.querySelector('summary').setAttribute('aria-expanded','false');
          }
        });
      });
    });
  }
}